import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { isValidDate } from "../../util/FormUtils";

const CustomDateFilterPicker = ({ dateFilters, field, startOrEnd, label, handleDateChange }) => {
    const [localDate, setLocalDate] = useState();

    useEffect(() => {
        setLocalDate(dateFilters[field][startOrEnd]);
    }, [dateFilters]);

    return (
        <DatePicker
            label={label}
            value={localDate ? dayjs(localDate) : null}
            onChange={(newDate) => setLocalDate(newDate ? newDate.format("YYYY-MM-DD") : null)}
            onAccept={(newDate) => handleDateChange(field, startOrEnd, newDate ? newDate.format("YYYY-MM-DD") : null)}
            format={"YYYY-MM-DD"}
            slotProps={{
                field: { clearable: true },
                textField: {
                    InputLabelProps: { shrink: true },
                    sx: { backgroundColor: isValidDate(localDate) ? "#cceeff" : "inherit" },
                    onBlur: (e) => handleDateChange(field, startOrEnd, e.target.value),
                },
            }}
            sx={{ width: 240, minWidth: 240, maxWidth: 240 }}
        />
    );
};

export default CustomDateFilterPicker;